if (!customElements.get('dr-box-purchase')) {
  customElements.define('dr-box-purchase', class extends HTMLElement {
    connectedCallback() {
      if (this.handleSubmit) return;
      this.handleSubmit = async (event) => {
        if (event.target !== this.querySelector('form')) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        if (this.busy) return;
        const form = event.target;
        if (!form.reportValidity()) return;
        const selected = form.querySelector('.dr-box-purchase__plans input:checked');
        const button = form.querySelector('.dr-box-purchase__submit');
        const error = form.querySelector('.dr-box-purchase__error');
        if (!selected) {
          error.textContent = this.dataset.error;
          error.hidden = false;
          error.focus();
          return;
        }
        const properties = {};
        form.querySelectorAll('[data-box-property]').forEach((field) => {
          const value = field.value.trim();
          if (value) properties[field.dataset.boxProperty] = value;
        });
        const item = { id: Number(form.querySelector('input[name="id"]').value), quantity: 1, properties };
        if (selected.value) item.selling_plan = Number(selected.value);
        const label = button.textContent;
        this.busy = true;
        button.disabled = true;
        button.textContent = this.dataset.loading;
        form.setAttribute('aria-busy', 'true');
        error.hidden = true;
        try {
          const response = await fetch(this.dataset.addUrl, {
            method: 'POST', credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ items: [item] })
          });
          if (!response.ok) throw new Error('cart');
          window.location.assign(this.dataset.cartUrl);
        } catch {
          error.textContent = this.dataset.error;
          error.hidden = false;
          error.focus();
          this.busy = false;
          button.disabled = false;
          button.textContent = label;
          form.removeAttribute('aria-busy');
        }
      };
      this.addEventListener('submit', this.handleSubmit, true);
    }
    disconnectedCallback() {
      if (this.handleSubmit) this.removeEventListener('submit', this.handleSubmit, true);
      this.handleSubmit = null;
    }
  });
}
